import React from 'react';
import {Container, Typography, Box, List, ListItem, Divider} from '@mui/material';
import SectionTitle from "./SectionTitle";

const skillList = {
    managementSkills: [
        {
            title: 'Team Management',
            description: 'Led fully remote, distributed teams and complex projects collaborating with stakeholders, product managers/designers'
        },
        {
            title: 'Project Management',
            description: 'Problem Solving • Project planning • Agile (Scrum/Kanban)'
        },
        {
            title: 'Communication',
            description: 'Negotiation • Decision-making • Conflict resolution • Documentation & roadmaps • Async team organization'
        },
        {
            title: 'People Management',
            description: 'Hiring • Mentoring • Performance evaluations'
        },
        {
            title: 'Technical Leadership',
            description: 'Code reviews • Architecture Design • CI/CD • Testing culture • Process improvements'
        },
    ],
    technicalSkillsFe: [
        'React.js • Vue.js • Next.js',
        'React Native • Flutter',
        'Redux • React-query • React Context',
        'SASS • Bootstrap • Twig',
        'MUI (Material-UI) • Tailwind CSS',
        'Jest • Cypress',
        'NPM • Yarn'
    ],
    technicalSkillsBe: [
        'Software design & architecture',
        'Node.js (Express, NestJS) • PHP (Symfony, Laravel)',
        'Doctrine • Firebase • MySQL • MongoDB • PostgreSQL',
        'Composer',
        'REST • GraphQL',
    ],
    technicalSkillsDevOps: [
        'Docker • Docker-Compose',
        'GitHub Actions • GitLab CI • Jenkins',
        'LEMP stack management',
        'Grafana • Kibana • Dynatrace • DataDog',
    ],
    other: [
        'Web marketing strategies (SEA • SMM • SEO • Email)',
        'Web analytics (Google Analytics)',
        'Copywriting • Web content writing',
    ],
}


function Skills() {

    const renderItem = (item, index, family) => {

        const listItemSx = {justifyContent: 'center', textAlign: 'center'};

        if (typeof item === 'string') {
            return (
                <ListItem key={`${family}_${index}`} sx={listItemSx}>
                    <Typography fontSize={'large'}>{item}</Typography>
                </ListItem>
            )
        }
        if (typeof item === 'object') {
            return (
                <>
                    <ListItem key={`${family}_${index}`} sx={{...listItemSx, paddingBottom: 0}}>
                        <Typography fontSize={'large'} fontWeight={'bold'}>{item.title}</Typography>
                    </ListItem>
                    <ListItem key={`${family}_${index}`} sx={{...listItemSx, paddingTop: 0}}>
                        <Typography fontSize={'large'}>{item.description}</Typography>
                    </ListItem>
                </>
            )
        }
    }

    const titleProps = {
        variant: "h4",
        align: 'center',
        fontWeight: 'bold',
        paddingTop: '24px',
        paddingBottom: '24px'
    }

    const listStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
    }

    return (
        <Container sx={{ padding: '64px 0',  overflow: 'hidden'}}>
            <SectionTitle title={'Skills'} />
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Divider />
                <Typography {...titleProps}>
                    {'// Leadership & Management'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.managementSkills.map((element, index) => (renderItem(element, index, 'managementSkills')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

                <Typography {...titleProps}>
                    {'// Frontend'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.technicalSkillsFe.map((element, index) => (renderItem(element, index, 'technicalSkillsFe')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

                <Typography {...titleProps}>
                    {'// Backend'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.technicalSkillsBe.map((element, index) => (renderItem(element, index, 'technicalSkillsBe')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

                <Typography {...titleProps}>
                    {'// DevOps'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.technicalSkillsDevOps.map((element, index) => (renderItem(element, index, 'technicalSkillsDevOps')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

                <Typography {...titleProps}>
                    {'// Other'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.other.map((element, index) => (renderItem(element, index, 'other')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

            </Box>
        </Container>
    );
}

export default Skills;